import { render } from "./ticketheader.vue?vue&type=template&id=5b3e15e4"
import script from "./ticketheader.vue?vue&type=script&lang=js"
export * from "./ticketheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__